import React from 'react'
import type { GradientBackgroundProps } from './GradientBackground.types'
import { Wrapper } from './GradientBackground.style'
import { COMUNICAR_STORY_TREE_HOME_ROOT_PATH } from 'routes/paths'
import { useHistory } from 'react-router-dom'

const GradientBackground: React.FC<GradientBackgroundProps> = ({
  color,
  children,
  id
}) => {
  const history = useHistory()
  const isStoryTreeComunicarPath =
    history.location.pathname === COMUNICAR_STORY_TREE_HOME_ROOT_PATH
  return (
    <Wrapper
      color={color}
      id={id}
      isStoryTreeComunicarPath={isStoryTreeComunicarPath}
    >
      {children}
    </Wrapper>
  )
}
export default GradientBackground
